var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#25E86F",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15C30.523 15 35 19.477 35 25C35 30.523 30.523 35 25 35C19.477 35 15 30.523 15 25C15 19.477 19.477 15 25 15ZM25 17C22.8783 17 20.8434 17.8429 19.3431 19.3431C17.8429 20.8434 17 22.8783 17 25C17 27.1217 17.8429 29.1566 19.3431 30.6569C20.8434 32.1571 22.8783 33 25 33C27.1217 33 29.1566 32.1571 30.6569 30.6569C32.1571 29.1566 33 27.1217 33 25C33 22.8783 32.1571 20.8434 30.6569 19.3431C29.1566 17.8429 27.1217 17 25 17ZM25 19C25.2449 19 25.4813 19.09 25.6644 19.2527C25.8474 19.4155 25.9643 19.6397 25.993 19.883L26 20V24.586L28.707 27.293C28.8863 27.473 28.9905 27.7144 28.9982 27.9684C29.006 28.2223 28.9168 28.4697 28.7488 28.6603C28.5807 28.8508 28.3464 28.9703 28.0935 28.9944C27.8406 29.0185 27.588 28.9454 27.387 28.79L27.293 28.707L24.293 25.707C24.1376 25.5514 24.0378 25.349 24.009 25.131L24 25V20C24 19.7348 24.1054 19.4804 24.2929 19.2929C24.4804 19.1054 24.7348 19 25 19Z",
    fill: "#088738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.44e7ecd502bf62b0454ea36589fa7d56.svg";
export { ForwardRef as ReactComponent };